import { EmptyState } from "components/core/empty";
import React from "react";
import { useTranslation } from "react-i18next";

export function NoConversationSelected(){

    const {t} = useTranslation();
    return <EmptyState className={"pt-24"} title={t("play-time.unselected.title")} description={t("play-time.unselected.description")}/>
}